export const checkAberrantBpData =  (bp, num) => {
    var status = 0;
    switch(true){
        case ( (bp=='hbp' || bp =='SYS')  && (num > 140 || num < 90)):
            status = 1;
            break;
        case ( (bp=='lbp' || bp =='DIAS')  && (num > 90 || num < 60)):
            status = 1;
            break;
        case ( (bp=='hb' || bp =='HB')  && (num > 100 || num < 60)):
            status = 1;
            break;
        case ( (bp=='rr' || bp =='RR')  && (num > 1200 || num < 600)):
            status = 1;
            break;
        case ( (bp=='rrv' || bp =='RRV')  && num >= 10):
            status = 1;
            break;
        case ( (bp=='st' || bp =='ST')  && num > 300):
            status = 1;
            break;
        case ( (bp=='sr' || bp =='SR')  && num > 100):
            status = 1;
            break;
    }
    return status;
}